import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'replaceParams'
})
export class ReplaceParamsPipe implements PipeTransform {

  transform(text: string, parameters: {}): string {

    // Remplaza todos los ${key} por el valor de parameters[key]
    text = text.replace(/\${([^}]+?)}/g, (match, key) => parameters.hasOwnProperty(key) ? parameters[key] : match);

    // Borra lo que esta entre corchetes dobles si contiene un undefined.
    // {{precio=undefined_5000}} => ''
    // {{precio=USD_5000}} => 'precio=USD_5000'
    text = text
      .replace(/{{((?!{{|}}).)*undefined((?!{{|}}\b).)*}}/g, '')
      .replace(/{{/g, '')
      .replace(/}}/g, '');

    return text;
  }

}
